export default function init() {
  const setAttributes = () => {
    const button = document.getElementById("MobileSideNavToggle")
    const sidebar = document.getElementById(button.getAttribute("aria-controls"))

    if (window.matchMedia("(min-width: 992px)").matches) {
      // Desktop
      button.setAttribute("aria-expanded", "true")
      sidebar.setAttribute("aria-hidden", "false")
    } else {
      // Mobile
      button.setAttribute("aria-expanded", "false")
      sidebar.setAttribute("aria-hidden", "true")
    }

    // sidenav smart sticky
    if (document.querySelector("aside.side-nav") && document.querySelector("main#Content")) {
      const sidenav = document.querySelector("aside.side-nav")
      const main = document.querySelector("main#Content")
      const sideHeight = sidenav.offsetHeight + 30 // 10 is the border thickness, 20 is the margin-bottom
      const mainHeight = main.offsetHeight + 40
      const viewportHeight = window.innerHeight

      if (window.innerWidth >= 992) {
        if (mainHeight > viewportHeight && sideHeight > viewportHeight) {
          sidenav.classList.add("non-sticky")
        } else {
          sidenav.classList.remove("non-sticky")
        }
      } else {
        sidenav.classList.remove("non-sticky")
      }
    }
  }

  const bindEvents = () => {
    const button = document.getElementById("MobileSideNavToggle")

    button.addEventListener("click", ev => {
      ev.preventDefault()
      const button = ev.currentTarget
      button.classList.toggle("side-nav__button--open")

      const sideNav = document.getElementById(button.getAttribute("aria-controls"))

      if (sideNav) {
        sideNav.classList.toggle("side-nav__nav--open")
        sideNav.setAttribute("aria-hidden", sideNav.classList.contains("side-nav__nav--open") ? "false" : "true")
      }
    })

    button.addEventListener("keydown", ev => {
      const sideNav = document.getElementById(button.getAttribute("aria-controls"))

      // On up arrow or escape key press close submenu
      if (ev.keyCode === 38 || ev.keyCode === 27) {
        button.classList.remove("side-nav__button--open")

        if (sideNav) {
          sideNav.classList.remove("side-nav__nav--open")
        }

        ev.preventDefault()
      }

      // On down arrow key press open sidebar
      if (ev.keyCode === 40) {
        button.classList.add("side-nav__button--open")

        if (sideNav) {
          sideNav.classList.add("side-nav__nav--open")
        }

        ev.preventDefault()
      }
    })

    window.addEventListener("resize", setAttributes)
  }

  const sidebar = document.querySelector(".side-nav")

  if (sidebar) {
    setAttributes()
    bindEvents()
  }
}
